/**
 * Consumer-rights "immediate service access" waiver — the art. 38 pkt 13
 * ustawy o prawach konsumenta acknowledgment: consent to BEGIN performance of
 * the digital service before the 14-day distance-contract cooling-off period
 * expires, coupled with the acknowledgment that this extinguishes the right of
 * withdrawal.
 *
 * Collected ONCE, at registration (contract conclusion). It is deliberately
 * NOT a `LegalDocumentType` and NOT part of the re-acceptance soft modal
 * (spec 2026-07-03-legal-consent-soft-modal): unlike Regulamin/Polityka it is
 * not a living, versioned document a user must re-accept when it changes — it
 * is a fixed, one-time consent tied to the moment of purchase.
 *
 * Brand-agnostic ("do Usługi") — one text and one version for every brand,
 * unlike `LEGAL_VERSIONS_BY_BRAND`. Bump {@link WITHDRAWAL_WAIVER_VERSION} in
 * the SAME commit as any wording change to {@link WITHDRAWAL_WAIVER_LABEL} so
 * the ledger keeps an honest record of which text a user actually accepted.
 *
 * Single source of truth: the frontend renders {@link WITHDRAWAL_WAIVER_LABEL}
 * as the checkbox label, the backend stamps {@link WITHDRAWAL_WAIVER_VERSION}
 * onto `legal_acceptances` + `users` — both read from here, never a hardcoded
 * copy (ADR-075 legal-content-as-SoT).
 */

/** Current version of the withdrawal-waiver acknowledgment text. */
export const WITHDRAWAL_WAIVER_VERSION = '2026-07-08';

/** The exact, mandatory checkbox text shown at registration. */
export const WITHDRAWAL_WAIVER_LABEL =
  'Wyrażam zgodę na natychmiastowe przyznanie mi dostępu do Usługi oraz przyjmuję do wiadomości, że jest to jednoznaczne z utratą prawa do odstąpienia od umowy zawartej na odległość';
